export default {
  // 通用按钮
  buttons: {
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    loading: 'Loading...',
    copy: 'Copy',
    share: 'Share',
    remove: 'Remove',
    login: 'Log in',
    signup: 'Sign up',
    startForFree: 'Start for free',
    check: 'Check',
    contactUsToModifyComments: 'Contact us to modify comments',
    confirmDelete: 'Confirm Delete',
    goBack: 'Go back',
    approve: 'Approve',
    notNow: 'Not now',
    update: 'Update',
    requestQuote: 'Request quote',
    later: 'Later',
    editCampaign: 'Edit campaign',
    startGroupChatLark: 'Start Group Chat（Lark）',
    messageCreator: 'Message creator',
    favorite: 'Favorite',
    submitInfo: 'Submit info',
    review: 'Review',
    completeSetup: 'Complete setup',
    counter: "Counter",
    pay: "Pay",
    send: "Send"
  },

  // 登录相关
  auth: {
    dontHaveAccount: "Don't have an account?",
    signUp: 'Sign up',
    needHelp: 'Need help? Contact us at',
    forgotPassword: 'Forgot password?',
    forgotPasswordPage: {
      title: 'Reset your password',
      subtitle: "Enter your email address and we'll send you a code to reset your password.",
      emailLabel: "Email",
      emailRequired: "Please enter your email",
      emailPlaceholder: "Enter your email",
      sendCode: "Send reset code",
      enterCodeTitle: 'Enter reset code',
      enterCodeSubtitle: 'We sent a code to {email}. Enter it below along with your new password.',
      codeLabel: 'Reset code',
      codeRequired: 'Please enter the reset code',
      codePlaceholder: "Enter reset code",
      resendAfter: "Resend in {seconds}s",
      resendCode: "Resend code",
      newPasswordLabel: "New password",
      newPasswordRequired: "Please enter your new password",
      newPasswordPlaceholder: "Enter new password",
      confirmPasswordLabel: "Confirm password",
      confirmPasswordRequired: "Please confirm your new password",
      confirmPasswordPlaceholder: "Enter new password again",
      resetPassword: "Reset password",
      backToEmail: "Back to email entry",
      rememberPassword: "Remember your password?",
      backToLogin: "Back to login",
      emailNotRegistered: "This email isn't registered yet. Please create an account first.",
      sendCodeError: "Failed to send reset code. Please try again.",
      confirmPasswordMismatch: "Two passwords do not match",
      resetError: "Failed to reset password. Please check your code and try again.",
      resendError: "Failed to resend code. Please try again.",
    },
  },

  // 移动端登录相关
  mobileAuth: {
    login: 'Login',
    pleaseLogin: 'Please log in',
    usingDesktopBrowser: 'using a desktop browser',
    getStartedMessage: 'To get started with the site, please open a desktop browser to access AhaCreator.',
    questionsMessage: 'If you have any questions or need assistance, please contact ',
    joinDiscord: 'Join AhaCreator\'s Discord'
  },
  
  // 通用状态
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    success: 'Success',
    error: 'Error',
  },
  
  // 通用消息
  messages: {
    copySuccess: 'Copy success.',
    copyFail: 'Copy fail.',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    confirmDelete: 'Are you sure you want to delete?',
    noData: 'No data available',
    loading: 'Loading...',
  },
  
  // 通用标签
  labels: {
    name: 'Name',
    description: 'Description',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    amount: 'Amount',
    quantity: 'Quantity',
    price: 'Price',
    total: 'Total',
  },
  signOut: 'Sign out',
  learnMore: 'Learn more',
  YouTube: 'YouTube',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
  LinkedIn: 'LinkedIn',
  Twitter: 'X (Twitter)',
  reviews: 'Reviews',
  loadMore: 'Load More',
  underReview: 'Under Review',
  reviewNotPassed: 'Review not passed',
  gotIt: 'Got it',
  influencers: 'influencers',
  report: 'Report',
  template: 'Template',
  refreshPage: 'Please refresh the page and try again.',
  reject: 'Reject',
  pendingActions: 'pending actions',
  followers: 'Followers',
  days: 'days',
  ok: 'OK',

  // 推广链接分享方式变更确认弹窗
  landingpageurlModeChangeConfirmModal: {
    title: 'Confirm updates to how you share the promotional link with the influencer',
    description:
      'Once you confirm this edit, it will affect influencers whose content has not yet been approved.',
  },

  // 达人追踪链接弹窗
  influencerTrackLinkModal: {
    title: 'Assign a unique promotional link to this influencer',
    description:
      'The influencer will include this link in their post or link in bio so their audience is directed to your destination.',
    uniqueLinkLabel: 'Unique link',
    uniqueLinkRequired: 'Please enter a unique promotional link for this influencer',
    uniqueLinkPlaceholder: 'Paste the influencer-specific URL',
    confirmSuccess: 'Submission successful',
  },
  influencersSelected: 'influencers selected',
  noLimit: 'No limit',
  noMinimum: 'No minimum',
};
